import React from "react"

const AllowedItemsSearchbar = ({ searchBarActive, handleResetQuery, setQuery, query, searchFieldLabel, clearSearchFieldLabel }) => {
  return (
    <div className="items-list-inner">
      <div className="form">
        <div className="form__section">
          <div className="form__section__inner">
            <div id="items-search-field" className="search-field">
              <input
                className="search-input"
                name="query"
                type="text"
                placeholder={searchFieldLabel || "Søg på genstande"}
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                autoComplete="off"
              />
              <button
                tabIndex={`${searchBarActive ? 0 : -1}`}
                aria-label={clearSearchFieldLabel || "Ryd søgefelt"}
                className={`search-button ${searchBarActive ? "active" : ""}`}
                aria-hidden={`${!searchBarActive}`}
                onClick={searchBarActive ? () => handleResetQuery() : undefined}
              >
                <div className="search-icon"></div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AllowedItemsSearchbar
